export const ACTIONS = {
  LOGIN: 'LOGIN',
  LOGIN_START: 'LOGIN_START',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  RESET_LOGIN: 'RESET_LOGIN',
  ADD_CLAIMS: 'ADD_CLAIMS',
};
